import { PermissionStatusCode } from './externe-apps';

export const externeAppsDefaultStatus = [
  { name: 'Aktiviert für diese Gemeinde', code: PermissionStatusCode.ACTIVATEDBYMUNICIPALITY, disabled: false },
  { name: 'Aktiviert für alle Gemeinden', code: PermissionStatusCode.ACTIVATEDALL, disabled: false },
  { name: 'Deaktiviert für diese Gemeinde', code: PermissionStatusCode.DEACTIVATEDBYMUNICIPALITY, disabled: true },
  { name: 'Deaktiviert für alle Gemeinden', code: PermissionStatusCode.DEACTIVATEDALL, disabled: false },
  { name: 'Teaser für diese Gemeinden', code: PermissionStatusCode.TEASERBYMUNICIPALITY, disabled: false },
  { name: 'Teaser für alle Gemeinden', code: PermissionStatusCode.TEASERALL, disabled: false },
];
